import React, {useEffect, useState} from "react"
import {ExpandedDesign} from "./design/ExpandedDesign"
import LegacyExpandedDesign from "./design/LegacyExpandedDesign"
import {Event} from "../../dtos/eventResponse"
import {PurcsData, CustomOrderData} from "../../dtos/orderResponse"
import {getField} from "../../utils/objectHelper"
import {WorkEntityServiceDependency} from "../../services/work/WorkEntityService"

interface DocumentProps {
	documentReferenceUrl: string
	tenantId: string
	workRevisionId: string
	orderIsLegacy: boolean
	livePreviewUrl: string
	lineItemId: string
	events: Event[]
	locale: string
	productKey: string
	purcsData: PurcsData
	tenantForPurcs: string
	customOrderData: CustomOrderData
	optionSelection: object
	previewInstructionsUri: string
}

export default function Document(props: DocumentProps) {
	const [optionSelections, setOptionSelections] = useState(undefined)

	useEffect(() => {
		const teamMemberId = getField({
			obj: props.customOrderData,
			key: "care.teamMemberId",
			defaultValue: "",
		})
		const workId = getField({
			obj: props.customOrderData,
			key: "analytics.workId",
			defaultValue: "",
		})
		const getUpdatedOptionSelections = async () => {
			const workLastRevision: any = await WorkEntityServiceDependency.getLastWorkRevision(workId)
			let groupData = workLastRevision?.resources?.groupsAndTeamsMembers

			if (typeof groupData === "string") {
				try {
					groupData = JSON.parse(groupData)
				} catch (e) {
					console.error("Invalid JSON in groupsAndTeamsMembers:", e)
					return {livePreviewUrl: null, docRefUrl: null}
				}
			}

			const member = groupData?.values?.find((value: any) => value.id === teamMemberId)

			if (
				member?.documentUrl === props.documentReferenceUrl &&
				workLastRevision &&
				workLastRevision.merchandising &&
				workLastRevision.merchandising.merchandisingSelections
			) {
				setOptionSelections(workLastRevision.merchandising.merchandisingSelections)
			}
		}
		if (teamMemberId && workId) getUpdatedOptionSelections()
	}, [props.documentReferenceUrl, props.customOrderData])

	function getRenderMethod() {
		if (
			props.tenantId &&
			props.productKey &&
			(props.workRevisionId || (props.documentReferenceUrl && props.optionSelection))
		)
			//If we meet the criteria of the expanded design render then use it
			return (
				<ExpandedDesign
					purcsData={props.purcsData}
					locale={props.locale}
					productKey={props.productKey}
					workRevisionId={props.workRevisionId}
					tenantId={props.tenantId}
					tenantForPurcs={props.tenantForPurcs}
					previewInstructionsUri={props.previewInstructionsUri}
					optionSelections={optionSelections ? optionSelections : props.optionSelection}
					docReferenceUrl={props.documentReferenceUrl}
					livePreviewUrl={props.livePreviewUrl}
					itemPreviewUrls={
						props.customOrderData?.care?.itemPreviewUrls ||
						props.customOrderData?.fulfillment?.itemPreviewUrls
					}
				/>
			)
		else if (props.orderIsLegacy)
			//Try and render the legacy document
			return <LegacyExpandedDesign renderUrl={props.documentReferenceUrl} />
		//Otherwise do a best effort
		else return <img src={props.livePreviewUrl} width="300px" alt="" />
	}

	return getRenderMethod()
}
